import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { withRouter } from "react-router";

import SidebarCategory from "components/sidebar/SidebarCategory";
import CATEGORIES from "utils/categories";
import { isPopulated, atLeastOneContributor } from "utils/helpers";

import "styles/Sidebar.scss";

class Sidebar extends Component {
  state = {
    top: 40,
    maxKeywords: 8,
  };
  isActive = (navlink) => this.props.location.pathname.indexOf(navlink) > -1;

  capKeywordLimit = (list) => {
    const { maxKeywords } = this.state;
    let newSummary;
    if (list.length > maxKeywords) {
      list.splice(maxKeywords, list.length);
      newSummary = list.join(", ");
      newSummary.concat("...");
    } else {
      newSummary = list.join(", ");
    }
    return newSummary;
  };

  getInterestSummary = (userIntFos) => {
    if (userIntFos.length === 0) return "Select your interests";
    const { INTEREST } = this.props.input.attributes;
    const interestList = userIntFos.map((int) => INTEREST[int].name);
    return this.capKeywordLimit(interestList);
  };

  getSkillSetSummary = (userSkills) => {
    if (userSkills.length === 0) return "Select your skills";
    const { SKILL } = this.props.input.attributes;
    const skillsList = userSkills.map((ski) => SKILL[ski].name);
    return this.capKeywordLimit(skillsList);
  };

  getPersonalitySummary = (userPersonality) => {
    if (userPersonality.length === 0) return "Select your personality";
    const personalityList = userPersonality.map((per) => per.personality_type);
    return this.capKeywordLimit(personalityList);
  };

  getCareerSummary = (userCareers) => {
    if (userCareers.length === 0) return "Select your intended career";
    const { CAREER } = this.props.input.attributes;
    const careerList = userCareers.map((car) => CAREER[car].name);
    return this.capKeywordLimit(careerList);
  };

  getCourseAreaSummary = (userCourses) => {
    if (userCourses.length === 0) return "Select your relevant uni course";
    const { courses } = this.props.input;
    const courseList = userCourses.map((key) => {
      return `${courses[key].title} (${courses[key].institution})`;
    });
    return this.capKeywordLimit(courseList);
  };

  getCategoryName = (navlink) => {
    return CATEGORIES.find((cat) => {
      return cat.navlink === navlink;
    }).name;
  };

  renderModuleBottom = () => (
    <NavLink to="/studies">
      <div className="sidebar-view-subjects">View Subjects</div>
    </NavLink>
  );

  render() {
    const { pathname } = this.props.location;

    const showInputSummary =
      pathname.match(/^\/summary/) !== null ? true : false;
    const disableInputSummary =
      pathname.match(/^\/summary\/atar-eligible/) !== null ? true : false;

    const {
      userInterests,
      userSkills,
      userPersonality,
      userCareers,
      userCourses,
    } = this.props;
    let summaries = {
      Interests: this.getInterestSummary(userInterests),
      SkillsSet: this.getSkillSetSummary(userSkills),
      Personality: this.getPersonalitySummary(userPersonality),
      Career: this.getCareerSummary(userCareers),
      CourseAreas: this.getCourseAreaSummary(userCourses),
    };

    return (
      <div
        className={
          "sidebar-container desktop-only " +
          (disableInputSummary ? "input-summary-disable" : "")
        }
      >
        <div className="vertical-grey-line" />
        <div className="sidebar">
          {CATEGORIES.map((cat, i) => (
            <NavLink
              key={cat.name}
              to={`/${cat.navlink}`}
              name={`/${cat.navlink}`}
            >
              <SidebarCategory
                active={this.isActive(`/${cat.navlink}`)}
                description={
                  showInputSummary ? summaries[cat.name] : cat.description
                }
                category={cat}
                complete={isPopulated(cat)}
                showInputSummary={showInputSummary}
                number={i} // making the top/bottom bars taller than the rest
              />
            </NavLink>
          ))}
          {atLeastOneContributor() && this.renderModuleBottom()}
        </div>
        <div className="vertical-grey-line" />
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  // general
  const { email } = store.emailReducer;
  const { input } = store.inputReducer;

  const { userInterests } = store.interestsReducer;
  const { userSkills } = store.skillsReducer;
  const { userPersonality } = store.personalityReducer;
  const { userCareers } = store.careersReducer;
  const { userCourses } = store.coursesReducer;

  const { userRecSubs } = store.pickRecSubReducer;
  const { userOthSubs } = store.pickOthSubReducer;
  const { userAddSubs } = store.pickAddSubReducer;

  return {
    // general
    email: email,
    input: input,

    // other user input
    userInterests: userInterests,
    userSkills: userSkills,
    userPersonality: userPersonality,
    userCareers: userCareers,
    userCourses: userCourses,

    userRecSubs: userRecSubs,
    userOthSubs: userOthSubs,
    userAddSubs: userAddSubs,
  };
};

export default withRouter(connect(mapStateToProps)(Sidebar));
